import { cn, V2Alert } from "@stacklet/ui";

interface Props {
  /** Error messages to render, one alert each; nothing is rendered when empty */
  messages: readonly string[];
  /** Classes for the stack itself, overriding its default `gap-xs` spacing */
  className?: string;
}

/**
 * Renders error messages as a stack of error alerts — the shared presentation
 * for `Problems` payloads ({@link InlineProblems}) and for form errors held in
 * `useFormErrors`.
 */
export function ErrorAlerts({ messages, className }: Props) {
  if (messages.length === 0) {
    return null;
  }

  return (
    <div className={cn("flex flex-col gap-xs", className)}>
      {/* The API can repeat a message, so the index keeps the keys unique */}
      {messages.map((message, index) => (
        <V2Alert key={`${index}-${message}`} severity="error">
          {message}
        </V2Alert>
      ))}
    </div>
  );
}
